"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokBlogEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Blog & Articles"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Latest Articles and Resources"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => handleChange({ ...content, description: v })}
              placeholder="Our Theme is your go-to resource..."
              multiline
            />
          </div>

          {/* Blog Posts */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Blog Posts</h4>
            <ListItemEditor
              label="Posts"
              items={content.posts || [
                { title: "Revolutionizing Digital Workflows with SaaS Dashboards", date: "25 March, 2026", comments: "2", image: "/assets/img/blog/blog_1_1.png" },
                { title: "Enhancing User Experience through AI Integration", date: "19 March, 2026", comments: "7", image: "/assets/img/blog/blog_1_2.png" },
                { title: "The Future of Remote Collaboration: Trends to Watch", date: "20 March, 2026", comments: "10", image: "/assets/img/blog/blog_1_3.png" },
                { title: "Innovative Strategies for Effective Team Management", date: "22 March, 2026", comments: "12", image: "/assets/img/blog/blog_1_4.png" },
              ]}
              itemSchema={[
                { key: "title", label: "Title", type: "text" },
                { key: "date", label: "Date", type: "text" },
                { key: "comments", label: "Comments", type: "text" },
                { key: "image", label: "Image", type: "image" },
                { key: "url", label: "URL", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, posts: items })}
              addItemText="Add Post"
            />
          </div>
        </>
      }
    />
  );
}
